import { render, staticRenderFns } from "./new_invoice.vue?vue&type=template&id=6b0fd368&lang=pug"
import script from "./new_invoice.vue?vue&type=script&lang=js"
export * from "./new_invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports